import React from 'react';
import { ScrollView, View } from 'react-native';
import {
  creditCardCodeNumber,
  getAvatarColor,
  hashtag,
  me_txt,
  userInitialsNameGM,
  userInitialsNameSD,
  userNameGM,
  userNameSD,
} from '../../utils/DictionaryManagementUtils';
import MyContactLine from './MyContactLine';

//= ========================================================================

const ParticipantContactList = ({
  globJSON,
  simPlatform,
  withSelected,
}) => {
  const { colors } = globJSON.configurations.theme;
  const colorToUse = (index) => {
    if (colors[getAvatarColor(index)] === hashtag) {
      return colorToUse(index - 1);
    }
    return colors[getAvatarColor(index)];
  };

  return (
    <ScrollView
      style={{
        flexDirection: 'column',
      }}
      vertical
      pagingEnabled={false}
      showsVerticalScrollIndicator={false}
      scrollEnabled
    >

      <View
        style={{
          width: 240,
          height: 1,
          marginLeft: 0,
          marginTop: 5,
          backgroundColor: colors.border_light_color,
        }}
      />

      <MyContactLine
        simPlatform={simPlatform}
        globJSON={globJSON}
        txtInitials={me_txt}
        txtPrimary={me_txt}
        withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
        withExpand={false}
        withCollapse={false}
        avatarColor={colorToUse(2)}
        selectedContact
      />

      <MyContactLine
        simPlatform={simPlatform}
        globJSON={globJSON}
        txtInitials={userInitialsNameSD}
        txtPrimary={userNameSD}
        txtSecondary={creditCardCodeNumber}
        withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
        withExpand={false}
        withCollapse={false}
        avatarColor={colorToUse(4)}
        selectedContact
      />

      <MyContactLine
        simPlatform={simPlatform}
        globJSON={globJSON}
        txtInitials={userInitialsNameGM}
        txtPrimary={userNameGM}
        txtSecondary={creditCardCodeNumber}
        withAvatar={globJSON.configurations.general.show_avatar_in_contact_lists}
        withCollapse={false}
        avatarColor={colorToUse(2)}
        selectedContact={withSelected}
      />
    </ScrollView>
  );
};
export default ParticipantContactList;
